/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  CreateDeviceMakerDto,
  DeviceMaker,
  DeviceMakersControllerCreateMakerPathParameters,
  DeviceMakersControllerDeleteMakerPathParameters,
  DeviceMakersControllerGetMakersPathParameters,
  DeviceMakersControllerUpdateMakerPathParameters,
  UpdateDeviceMakerDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class DeviceMakersService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Retrieve all device makers for a client
   */

  getMakers<TData = DeviceMaker[]>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
  }: DeviceMakersControllerGetMakersPathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/device-makers`);
  }
  /**
   * @summary Create a new device maker
   */

  createMaker<TData = DeviceMaker>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: DeviceMakersControllerCreateMakerPathParameters,
    createDeviceMakerDto: CreateDeviceMakerDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/device-makers`, createDeviceMakerDto);
  }
  /**
   * @summary Edit device maker
   */

  updateMaker<TData = DeviceMaker>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, id }: DeviceMakersControllerUpdateMakerPathParameters,
    updateDeviceMakerDto: UpdateDeviceMakerDto,
  ): Observable<TData> {
    return this.http.patch<TData>(`/devices/v1/clients/${clientId}/device-makers/${id}`, updateDeviceMakerDto);
  }
  /**
   * @summary Delete device maker
   */

  deleteMaker<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    id,
  }: DeviceMakersControllerDeleteMakerPathParameters): Observable<TData> {
    return this.http.delete<TData>(`/devices/v1/clients/${clientId}/device-makers/${id}`);
  }
}
